export const esignProductTierNames = {
  HELLOSIGN: 'E-Sign',
  SIMPLESIGN: 'Simple Sign',
};



// WEBPACK FOOTER //
// ./src/constants/esignProductTierNames.js